import Vue from '../main/vue';
import SloOnlineDistributors from '../../lib/components/SloOnlineDistributors.vue';

const loadSupplyChainMap = () => {
  if (document.querySelector('.online-distributors-page')) {
    new Vue({
      el: '.online-distributors-page',
      comments: true,
      components: {
        'slo-online-distributors': SloOnlineDistributors
      }
    });
  }
};

export default loadSupplyChainMap;
